@if (accaBoostNotification(); as notification) {
    @if (isNotificationType(notification, 'Error')) {
        <bs-acca-boost-notification
            class="acca-boost-notification--error quick-bet-acca-boost-notification"
            [class.acca-boost-notification-enhanced]="isEnhancedLayoutEnabled"
            [showAccaBoostIcon]="true"
            [showInfoIcon]="false"
            [notification]="notification"
            [usLadderEnabled]="false"
            @accaBoostNotificationAnimation>
            <bs-acca-boost-error [token]="notification.token" [error]="notification.error" [isTrendingAccas]="notification.isTrendingAccasSelected" />
        </bs-acca-boost-notification>
    }

    @if (isNotificationType(notification, 'OneSelectionAway')) {
        <bs-acca-boost-notification
            class="acca-boost-notification--teaser quick-bet-acca-boost-notification"
            [class.acca-boost-notification-enhanced]="isEnhancedLayoutEnabled"
            [notification]="notification"
            [showInfoIcon]="false"
            [showAccaBoostIcon]="true"
            [usLadderEnabled]="false"
            [ngClass]="{ 'acca-boost-notification-enhanced': isEnhancedLayoutEnabled }"
            @accaBoostNotificationAnimation>
            <bs-acca-boost-teaser [token]="notification.token" />
        </bs-acca-boost-notification>
    }
}
